<script>
import { FormatPercentSales } from "../../utils";
export default {
  name: "HyperlinSalesTotal",
  functional: true,
  props: {
    row: Object,
    column: String,
    mes: Number,
    openDetail: Function
  },
  render: function (createElement, context) {
    const val = Number(context.props.row[context.props.column]);
    // const MetaAnual = context.props.row.AnualTarget;
    // const VentaAnual = context.props.row.Totals;

    let classs = "info";

    // if (VentaAnual / (MetaAnual / 12) / 100 <= 70) {
    //   classs = "red";
    // } else if (VentaAnual / (MetaAnual / 12) / 100 >= 90) {
    //   classs = "green";
    // } else if (VentaAnual / (MetaAnual / 12) / 100 >= 71 && val <= 89) {
    //   classs = "golden";
    // }

    const MothValue = function (val) {
      if (val > 0) {
        return FormatPercentSales(val);
      } else {
        return "";
      }
    };

    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#",
          class: classs
        },
        on: {
          //   click: () => {
          //     const { mes, row, openDetail } = context.props;
          //     openDetail(mes, row);
          //   }
        }
      },
      MothValue(val)
    );
  }
};
</script>
<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
</style>
